import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { housingStatusApi } from '../api/housingStatus.api';
import { housingStatusKeys } from '../api/housingStatus.keys';

export function useHousingStatusList(params: any) {
  return useQuery({
    queryKey: housingStatusKeys.list(params),
    queryFn: () => housingStatusApi.list(params),
    placeholderData: keepPreviousData,
  });
}

export function useHousingStatusDetails(id: any) {
  return useQuery({
    queryKey: housingStatusKeys.detail(id),
    queryFn: () => housingStatusApi.getById(id),
    enabled: !!id,
  });
}
